/** Keys Mapbox adds on clustered features — hide from attribute popup. */
const CLUSTER_META = new Set(['cluster_id', 'point_count', 'point_count_abbreviated']);

/**
 * @param popupFields `undefined` → show every property (except cluster meta).
 *                  non-empty array → only those keys (in stable schema order when possible).
 *                  empty array → show nothing.
 */
export function popupPropertyEntries(
  properties: Record<string, unknown>,
  popupFields: string[] | undefined,
  orderedKeys?: string[],
): [string, unknown][] {
  const raw = Object.entries(properties).filter(([k]) => !CLUSTER_META.has(k));

  if (popupFields === undefined) {
    return raw;
  }
  if (popupFields.length === 0) {
    return [];
  }
  const allow = new Set(popupFields);
  const map = new Map(raw);
  const out: [string, unknown][] = [];
  if (orderedKeys?.length) {
    for (const k of orderedKeys) {
      if (allow.has(k) && map.has(k)) {
        out.push([k, map.get(k) as unknown]);
      }
    }
    for (const [k, v] of raw) {
      if (allow.has(k) && !out.some(([x]) => x === k)) {
        out.push([k, v]);
      }
    }
    return out;
  }
  return raw.filter(([k]) => allow.has(k));
}
